// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"7a4977b8","288":"ab31f0f3","409":"2d00b6d5","453":"af205ec6","578":"d6293042","749":"d6444b8e","914":"43141cd2"}[chunkId] + ".chunk.js";
};